export * from "@floating-ui/react-dom";
//# sourceMappingURL=Floating.mjs.map
